export enum LossTypeEnum {
  IRON = 'losses_iron',
  TOTAL_LOSSES = 'losses_total',
  LOSSES = 'losses',
  EFFICIENCIES = 'efficiencies',
  POWER = 'power',
  DEFAULT = 'default',
}
